import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetDistributionJobsDetailsProps {
  communityId: string;
  jobId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionJobsDetails = async (jobId: string, communityId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_JOBS_API(communityId)}/${jobId}/run-details`);

const useGetDistributionJobsDetails = ({
  queryParams,
  jobId,
  communityId
}: UseGetDistributionJobsDetailsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-jobs-details", jobId],
    queryFn: () => getDistributionJobsDetails(jobId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!jobId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionJobsDetails;
